import { useState, useCallback, useEffect } from 'react';

let globalLimitHandler = null;

export const setGlobalLimitHandler = (handler) => {
  globalLimitHandler = handler;
};

export const triggerLimitExceeded = (limitType) => {
  if (globalLimitHandler) {
    globalLimitHandler(limitType);
  }
};

const useLimitHandler = () => {
  const [limitModalOpen, setLimitModalOpen] = useState(false);
  const [limitType, setLimitType] = useState('video');

  const handleLimitExceeded = useCallback((type) => {
    setLimitType(type || 'video');
    setLimitModalOpen(true);
  }, []);

  const closeLimitModal = useCallback(() => {
    setLimitModalOpen(false);
  }, []);

  useEffect(() => {
    setGlobalLimitHandler(handleLimitExceeded);
    return () => {
      setGlobalLimitHandler(null);
    };
  }, [handleLimitExceeded]);

  return {
    limitModalOpen,
    limitType,
    closeLimitModal,
  };
};

export default useLimitHandler;
